var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatewayPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 500,
    viewBox: "0 0 402 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.6997 -51.9912L77.1812 -70.2224L61.6037 -54.8836L68.3603 -48.2313L77.1812 -56.9155L82.1819 -51.9912L65.4215 -35.488L48.6634 -51.9912L65.4215 -68.4944L68.1498 -65.8078L74.9087 -72.4647L65.4215 -81.8013L35.148 -51.9912L65.4215 -22.1765L95.6997 -51.9912Z",
    fill: "url(#paint0_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77 -51.9912L148.251 -70.2224L132.674 -54.8836L139.432 -48.2313L148.251 -56.9155L153.252 -51.9912L136.494 -35.488L119.733 -51.9912L136.494 -68.4944L139.222 -65.8078L145.979 -72.4647L136.494 -81.8013L106.218 -51.9912L136.494 -22.1765L166.77 -51.9912Z",
    fill: "url(#paint1_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.643 -52.1899L219.125 -70.4211L203.547 -55.0823L210.304 -48.4277L219.125 -57.1143L224.125 -52.1899L207.367 -35.6867L190.607 -52.1899L207.367 -68.6932L210.096 -66.0065L216.852 -72.6635L207.367 -82L177.091 -52.1899L207.367 -22.3752L237.643 -52.1899Z",
    fill: "url(#paint2_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.517 -51.9912L289.998 -70.2224L274.421 -54.8836L281.177 -48.2313L289.998 -56.9155L294.999 -51.9912L278.238 -35.488L261.48 -51.9912L278.238 -68.4944L280.967 -65.8078L287.726 -72.4647L278.238 -81.8013L247.965 -51.9912L278.238 -22.1765L308.517 -51.9912Z",
    fill: "url(#paint3_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.586 -51.9912L361.068 -70.2224L345.491 -54.8836L352.247 -48.2313L361.068 -56.9155L366.069 -51.9912L349.311 -35.488L332.55 -51.9912L349.311 -68.4944L352.039 -65.8078L358.795 -72.4647L349.311 -81.8013L319.035 -51.9912L349.311 -22.1765L379.586 -51.9912Z",
    fill: "url(#paint4_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.46 -52.1899L431.941 -70.4211L416.364 -55.0823L423.121 -48.4277L431.941 -57.1143L436.942 -52.1899L420.182 -35.6867L403.424 -52.1899L420.182 -68.6932L422.91 -66.0065L429.669 -72.6635L420.182 -82L389.908 -52.1899L420.182 -22.3752L450.46 -52.1899Z",
    fill: "url(#paint5_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.333 -51.9912L502.813 -70.2224L487.235 -54.8836L493.994 -48.2313L502.813 -56.9155L507.816 -51.9912L491.055 -35.488L474.295 -51.9912L491.055 -68.4944L493.784 -65.8078L500.54 -72.4647L491.055 -81.8013L460.782 -51.9912L491.055 -22.1765L521.333 -51.9912Z",
    fill: "url(#paint6_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.403 -51.9912L573.885 -70.2224L558.307 -54.8836L565.064 -48.2313L573.885 -56.9155L578.886 -51.9912L562.125 -35.488L545.367 -51.9912L562.125 -68.4944L564.854 -65.8078L571.612 -72.4647L562.125 -81.8013L531.852 -51.9912L562.125 -22.1765L592.403 -51.9912Z",
    fill: "url(#paint7_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.277 -52.1899L644.756 -70.4211L629.179 -55.0823L635.937 -48.4277L644.756 -57.1143L649.759 -52.1899L632.999 -35.6867L616.238 -52.1899L632.999 -68.6932L635.727 -66.0065L642.484 -72.6635L632.999 -82L602.725 -52.1899L632.999 -22.3752L663.277 -52.1899Z",
    fill: "url(#paint8_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 -13.3754L42.0331 -31.6065L26.4557 -16.2678L33.2122 -9.61317L42.0331 -18.2997L47.0339 -13.3754L30.2735 3.12783L13.5154 -13.3754L30.2735 -29.8786L33.0018 -27.192L39.7607 -33.8489L30.2735 -43.1854L0 -13.3754L30.2735 16.4394L60.5517 -13.3754Z",
    fill: "url(#paint9_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.724 16.4394L699 -13.3754L680.481 -31.6065L664.904 -16.2678L671.661 -9.61317L680.481 -18.2997L685.482 -13.3754L668.724 3.12783L651.964 -13.3754L668.724 -29.8786L671.453 -27.192L678.209 -33.8489L668.724 -43.1854L638.448 -13.3754L668.724 16.4394Z",
    fill: "url(#paint10_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.346 16.4394L131.622 -13.3754L113.103 -31.6065L97.5256 -16.2678L104.284 -9.61317L113.103 -18.2997L118.104 -13.3754L101.346 3.12783L84.5853 -13.3754L101.346 -29.8786L104.074 -27.192L110.831 -33.8489L101.346 -43.1854L71.0699 -13.3754L101.346 16.4394Z",
    fill: "url(#paint11_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.217 16.2406L202.495 -13.5718L183.977 -31.8053L168.399 -16.4665L175.156 -9.81192L183.977 -18.4961L188.977 -13.5718L172.217 2.93142L155.459 -13.5718L172.217 -30.075L174.945 -27.3884L181.704 -34.0453L172.217 -43.3842L141.943 -13.5718L172.217 16.2406Z",
    fill: "url(#paint12_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09 16.4394L273.369 -13.3754L254.85 -31.6065L239.273 -16.2678L246.029 -9.61317L254.85 -18.2997L259.851 -13.3754L243.09 3.12783L226.33 -13.3754L243.09 -29.8786L245.819 -27.192L252.578 -33.8489L243.09 -43.1854L212.817 -13.3754L243.09 16.4394Z",
    fill: "url(#paint13_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.163 16.4394L344.438 -13.3754L325.92 -31.6065L310.342 -16.2678L317.099 -9.61317L325.92 -18.2997L330.921 -13.3754L314.163 3.12783L297.402 -13.3754L314.163 -29.8786L316.889 -27.192L323.647 -33.8489L314.163 -43.1854L283.887 -13.3754L314.163 16.4394Z",
    fill: "url(#paint14_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.034 16.2406L415.312 -13.5718L396.793 -31.8053L381.216 -16.4665L387.973 -9.81192L396.793 -18.4961L401.794 -13.5718L385.034 2.93142L368.273 -13.5718L385.034 -30.075L387.762 -27.3884L394.521 -34.0453L385.034 -43.3842L354.76 -13.5718L385.034 16.2406Z",
    fill: "url(#paint15_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.907 16.4394L486.183 -13.3754L467.665 -31.6065L452.087 -16.2678L458.846 -9.61317L467.665 -18.2997L472.665 -13.3754L455.907 3.12783L439.147 -13.3754L455.907 -29.8786L458.636 -27.192L465.392 -33.8489L455.907 -43.1854L425.631 -13.3754L455.907 16.4394Z",
    fill: "url(#paint16_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.977 16.4394L557.255 -13.3754L538.737 -31.6065L523.159 -16.2678L529.916 -9.61317L538.737 -18.2997L543.738 -13.3754L526.977 3.12783L510.219 -13.3754L526.977 -29.8786L529.705 -27.192L536.464 -33.8489L526.977 -43.1854L496.704 -13.3754L526.977 16.4394Z",
    fill: "url(#paint17_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.851 16.2406L628.126 -13.5718L609.608 -31.8053L594.031 -16.4665L600.789 -9.81192L609.608 -18.4961L614.609 -13.5718L597.851 2.93142L581.09 -13.5718L597.851 -30.075L600.579 -27.3884L607.336 -34.0453L597.851 -43.3842L567.575 -13.5718L597.851 16.2406Z",
    fill: "url(#paint18_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6634 25.1469L65.4215 8.64371L68.1498 11.3303L74.9087 4.67339L65.4215 -4.66315L35.148 25.1469L65.4215 54.9616L95.6997 25.1469L77.1812 6.91575L61.6037 22.2545L68.3603 28.9068L77.1812 20.2226L82.1819 25.1469L65.4215 41.6501L48.6634 25.1469Z",
    fill: "url(#paint19_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 25.1469L136.494 8.64371L139.222 11.3303L145.979 4.67339L136.494 -4.66315L106.218 25.1469L136.494 54.9616L166.77 25.1469L148.251 6.91575L132.674 22.2545L139.432 28.9068L148.251 20.2226L153.252 25.1469L136.494 41.6501L119.733 25.1469Z",
    fill: "url(#paint20_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.607 24.9482L207.367 8.4473L210.096 11.1339L216.852 4.47698L207.367 -4.86189L177.091 24.9482L207.367 54.7629L237.643 24.9482L219.125 6.71701L203.547 22.0558L210.304 28.7104L219.125 20.0238L224.125 24.9482L207.367 41.4514L190.607 24.9482Z",
    fill: "url(#paint21_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48 25.1469L278.238 8.64371L280.967 11.3303L287.726 4.67339L278.238 -4.66315L247.965 25.1469L278.238 54.9616L308.517 25.1469L289.998 6.91575L274.421 22.2545L281.177 28.9068L289.998 20.2226L294.999 25.1469L278.238 41.6501L261.48 25.1469Z",
    fill: "url(#paint22_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55 25.1469L349.311 8.64371L352.039 11.3303L358.795 4.67339L349.311 -4.66315L319.035 25.1469L349.311 54.9616L379.586 25.1469L361.068 6.91575L345.491 22.2545L352.247 28.9068L361.068 20.2226L366.069 25.1469L349.311 41.6501L332.55 25.1469Z",
    fill: "url(#paint23_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.424 24.9482L420.182 8.4473L422.91 11.1339L429.669 4.47698L420.182 -4.86189L389.908 24.9482L420.182 54.7629L450.46 24.9482L431.941 6.71701L416.364 22.0558L423.121 28.7104L431.941 20.0238L436.942 24.9482L420.182 41.4514L403.424 24.9482Z",
    fill: "url(#paint24_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.295 25.1469L491.055 8.64371L493.784 11.3303L500.54 4.67339L491.055 -4.66315L460.782 25.1469L491.055 54.9616L521.333 25.1469L502.813 6.91575L487.235 22.2545L493.994 28.9068L502.813 20.2226L507.816 25.1469L491.055 41.6501L474.295 25.1469Z",
    fill: "url(#paint25_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.367 25.1469L562.125 8.64371L564.854 11.3303L571.612 4.67339L562.125 -4.66315L531.852 25.1469L562.125 54.9616L592.403 25.1469L573.885 6.91575L558.307 22.2545L565.064 28.9068L573.885 20.2226L578.886 25.1469L562.125 41.6501L545.367 25.1469Z",
    fill: "url(#paint26_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.756 6.71701L629.179 22.0558L635.937 28.7104L644.756 20.0238L649.759 24.9482L632.999 41.4514L616.238 24.9482L632.999 8.4473L635.727 11.1339L642.484 4.47698L632.999 -4.86189L602.725 24.9482L632.999 54.7629L663.277 24.9482L644.756 6.71701Z",
    fill: "url(#paint27_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 63.7627L42.0331 45.5316L26.4557 60.8703L33.2122 67.5249L42.0331 58.8384L47.0339 63.7627L30.2735 80.2659L13.5154 63.7627L30.2735 47.2595L33.0018 49.9461L39.7607 43.2916L30.2735 33.9527L0 63.7627L30.2735 93.5775L60.5517 63.7627Z",
    fill: "url(#paint28_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 60.8703L671.661 67.5249L680.481 58.8384L685.482 63.7627L668.724 80.2659L651.964 63.7627L668.724 47.2595L671.453 49.9461L678.209 43.2916L668.724 33.9527L638.448 63.7627L668.724 93.5775L699 63.7627L680.481 45.5316L664.904 60.8703Z",
    fill: "url(#paint29_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0699 63.7627L101.346 93.5775L131.622 63.7627L113.103 45.5316L97.5256 60.8703L104.284 67.5249L113.103 58.8384L118.104 63.7627L101.346 80.2659L84.5853 63.7627L101.346 47.2595L104.074 49.9461L110.831 43.2916L101.346 33.9527L71.0699 63.7627Z",
    fill: "url(#paint30_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.943 63.5663L172.217 93.3787L202.495 63.5663L183.977 45.3328L168.399 60.6716L175.156 67.3262L183.977 58.642L188.977 63.5663L172.217 80.0695L155.459 63.5663L172.217 47.0631L174.945 49.7497L181.704 43.0928L172.217 33.7539L141.943 63.5663Z",
    fill: "url(#paint31_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.817 63.7627L243.09 93.5775L273.369 63.7627L254.85 45.5316L239.273 60.8703L246.029 67.5249L254.85 58.8384L259.851 63.7627L243.09 80.2659L226.33 63.7627L243.09 47.2595L245.819 49.9461L252.578 43.2916L243.09 33.9527L212.817 63.7627Z",
    fill: "url(#paint32_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.887 63.7627L314.163 93.5775L344.438 63.7627L325.92 45.5316L310.342 60.8703L317.099 67.5249L325.92 58.8384L330.921 63.7627L314.163 80.2659L297.402 63.7627L314.163 47.2595L316.889 49.9461L323.647 43.2916L314.163 33.9527L283.887 63.7627Z",
    fill: "url(#paint33_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76 63.5663L385.034 93.3787L415.312 63.5663L396.793 45.3328L381.216 60.6716L387.973 67.3262L396.793 58.642L401.794 63.5663L385.034 80.0695L368.273 63.5663L385.034 47.0631L387.762 49.7497L394.521 43.0928L385.034 33.7539L354.76 63.5663Z",
    fill: "url(#paint34_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.631 63.7627L455.907 93.5775L486.183 63.7627L467.665 45.5316L452.087 60.8703L458.846 67.5249L467.665 58.8384L472.665 63.7627L455.907 80.2659L439.147 63.7627L455.907 47.2595L458.636 49.9461L465.392 43.2916L455.907 33.9527L425.631 63.7627Z",
    fill: "url(#paint35_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.704 63.7627L526.977 93.5775L557.255 63.7627L538.737 45.5316L523.159 60.8703L529.916 67.5249L538.737 58.8384L543.738 63.7627L526.977 80.2659L510.219 63.7627L526.977 47.2595L529.705 49.9461L536.464 43.2916L526.977 33.9527L496.704 63.7627Z",
    fill: "url(#paint36_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09 63.5663L597.851 47.0631L600.579 49.7497L607.336 43.0928L597.851 33.7539L567.575 63.5663L597.851 93.3787L628.126 63.5663L609.608 45.3328L594.031 60.6716L600.789 67.3262L609.608 58.642L614.609 63.5663L597.851 80.0695L581.09 63.5663Z",
    fill: "url(#paint37_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4215 132.298L95.6997 102.484L77.1812 84.2503L61.6037 99.589L68.3603 106.244L77.1812 97.5594L82.1819 102.484L65.4215 118.987L48.6634 102.484L65.4215 85.9805L68.1498 88.6672L74.9087 82.0103L65.4215 72.6737L35.148 102.484L65.4215 132.298Z",
    fill: "url(#paint38_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 102.484L136.494 85.9805L139.222 88.6672L145.979 82.0103L136.494 72.6737L106.218 102.484L136.494 132.298L166.77 102.484L148.251 84.2503L132.674 99.589L139.432 106.244L148.251 97.5594L153.252 102.484L136.494 118.987L119.733 102.484Z",
    fill: "url(#paint39_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.607 102.285L207.367 85.7818L210.096 88.4684L216.852 81.8115L207.367 72.475L177.091 102.285L207.367 132.1L237.643 102.285L219.125 84.0538L203.547 99.3926L210.304 106.045L219.125 97.3607L224.125 102.285L207.367 118.788L190.607 102.285Z",
    fill: "url(#paint40_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48 102.484L278.238 85.9805L280.967 88.6672L287.726 82.0103L278.238 72.6737L247.965 102.484L278.238 132.298L308.517 102.484L289.998 84.2503L274.421 99.589L281.177 106.244L289.998 97.5594L294.999 102.484L278.238 118.987L261.48 102.484Z",
    fill: "url(#paint41_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55 102.484L349.311 85.9805L352.039 88.6672L358.795 82.0103L349.311 72.6737L319.035 102.484L349.311 132.298L379.586 102.484L361.068 84.2503L345.491 99.589L352.247 106.244L361.068 97.5594L366.069 102.484L349.311 118.987L332.55 102.484Z",
    fill: "url(#paint42_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.424 102.285L420.182 85.7818L422.91 88.4684L429.669 81.8115L420.182 72.475L389.908 102.285L420.182 132.1L450.46 102.285L431.941 84.0538L416.364 99.3926L423.121 106.045L431.941 97.3607L436.942 102.285L420.182 118.788L403.424 102.285Z",
    fill: "url(#paint43_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.295 102.484L491.055 85.9805L493.784 88.6672L500.54 82.0103L491.055 72.6737L460.782 102.484L491.055 132.298L521.333 102.484L502.813 84.2503L487.235 99.589L493.994 106.244L502.813 97.5594L507.816 102.484L491.055 118.987L474.295 102.484Z",
    fill: "url(#paint44_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.367 102.484L562.125 85.9805L564.854 88.6672L571.612 82.0103L562.125 72.6737L531.852 102.484L562.125 132.298L592.403 102.484L573.885 84.2503L558.307 99.589L565.064 106.244L573.885 97.5594L578.886 102.484L562.125 118.987L545.367 102.484Z",
    fill: "url(#paint45_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.238 102.285L632.999 85.7818L635.727 88.4684L642.484 81.8115L632.999 72.475L602.725 102.285L632.999 132.1L663.277 102.285L644.756 84.0538L629.179 99.3926L635.937 106.045L644.756 97.3607L649.759 102.285L632.999 118.788L616.238 102.285Z",
    fill: "url(#paint46_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 141.1L42.0331 122.868L26.4557 138.207L33.2122 144.859L42.0331 136.175L47.0339 141.1L30.2735 157.603L13.5154 141.1L30.2735 124.596L33.0018 127.283L39.7607 120.626L30.2735 111.29L0 141.1L30.2735 170.914L60.5517 141.1Z",
    fill: "url(#paint47_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 138.207L671.661 144.859L680.481 136.175L685.482 141.1L668.724 157.603L651.964 141.1L668.724 124.596L671.453 127.283L678.209 120.626L668.724 111.29L638.448 141.1L668.724 170.914L699 141.1L680.481 122.868L664.904 138.207Z",
    fill: "url(#paint48_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0699 141.1L101.346 170.914L131.622 141.1L113.103 122.868L97.5256 138.207L104.284 144.859L113.103 136.175L118.104 141.1L101.346 157.603L84.5853 141.1L101.346 124.596L104.074 127.283L110.831 120.626L101.346 111.29L71.0699 141.1Z",
    fill: "url(#paint49_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.943 140.901L172.217 170.716L202.495 140.901L183.977 122.67L168.399 138.008L175.156 144.663L183.977 135.977L188.977 140.901L172.217 157.404L155.459 140.901L172.217 124.4L174.945 127.087L181.704 120.43L172.217 111.091L141.943 140.901Z",
    fill: "url(#paint50_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.817 141.1L243.09 170.914L273.369 141.1L254.85 122.868L239.273 138.207L246.029 144.859L254.85 136.175L259.851 141.1L243.09 157.603L226.33 141.1L243.09 124.596L245.819 127.283L252.578 120.626L243.09 111.29L212.817 141.1Z",
    fill: "url(#paint51_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.887 141.1L314.163 170.914L344.438 141.1L325.92 122.868L310.342 138.207L317.099 144.859L325.92 136.175L330.921 141.1L314.163 157.603L297.402 141.1L314.163 124.596L316.889 127.283L323.647 120.626L314.163 111.29L283.887 141.1Z",
    fill: "url(#paint52_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76 140.901L385.034 170.716L415.312 140.901L396.793 122.67L381.216 138.008L387.973 144.663L396.793 135.977L401.794 140.901L385.034 157.404L368.273 140.901L385.034 124.4L387.762 127.087L394.521 120.43L385.034 111.091L354.76 140.901Z",
    fill: "url(#paint53_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.631 141.1L455.907 170.914L486.183 141.1L467.665 122.868L452.087 138.207L458.846 144.859L467.665 136.175L472.665 141.1L455.907 157.603L439.147 141.1L455.907 124.596L458.636 127.283L465.392 120.626L455.907 111.29L425.631 141.1Z",
    fill: "url(#paint54_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.704 141.1L526.977 170.914L557.255 141.1L538.737 122.868L523.159 138.207L529.916 144.859L538.737 136.175L543.738 141.1L526.977 157.603L510.219 141.1L526.977 124.596L529.705 127.283L536.464 120.626L526.977 111.29L496.704 141.1Z",
    fill: "url(#paint55_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09 140.901L597.851 124.4L600.579 127.087L607.336 120.43L597.851 111.091L567.575 140.901L597.851 170.716L628.126 140.901L609.608 122.67L594.031 138.008L600.789 144.663L609.608 135.977L614.609 140.901L597.851 157.404L581.09 140.901Z",
    fill: "url(#paint56_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4215 209.437L95.6997 179.622L77.1812 161.388L61.6037 176.727L68.3603 183.382L77.1812 174.698L82.1819 179.622L65.4215 196.125L48.6634 179.622L65.4215 163.119L68.1498 165.805L74.9087 159.148L65.4215 149.812L35.148 179.622L65.4215 209.437Z",
    fill: "url(#paint57_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.733 179.622L136.494 163.119L139.222 165.805L145.979 159.148L136.494 149.812L106.218 179.622L136.494 209.437L166.77 179.622L148.251 161.388L132.674 176.727L139.432 183.382L148.251 174.698L153.252 179.622L136.494 196.125L119.733 179.622Z",
    fill: "url(#paint58_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.607 179.423L207.367 162.92L210.096 165.607L216.852 158.95L207.367 149.613L177.091 179.423L207.367 209.238L237.643 179.423L219.125 161.192L203.547 176.531L210.304 183.183L219.125 174.499L224.125 179.423L207.367 195.926L190.607 179.423Z",
    fill: "url(#paint59_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48 179.622L278.238 163.119L280.967 165.805L287.726 159.148L278.238 149.812L247.965 179.622L278.238 209.437L308.517 179.622L289.998 161.388L274.421 176.727L281.177 183.382L289.998 174.698L294.999 179.622L278.238 196.125L261.48 179.622Z",
    fill: "url(#paint60_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55 179.622L349.311 163.119L352.039 165.805L358.795 159.148L349.311 149.812L319.035 179.622L349.311 209.437L379.586 179.622L361.068 161.388L345.491 176.727L352.247 183.382L361.068 174.698L366.069 179.622L349.311 196.125L332.55 179.622Z",
    fill: "url(#paint61_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.424 179.423L420.182 162.92L422.91 165.607L429.669 158.95L420.182 149.613L389.908 179.423L420.182 209.238L450.46 179.423L431.941 161.192L416.364 176.531L423.121 183.183L431.941 174.499L436.942 179.423L420.182 195.926L403.424 179.423Z",
    fill: "url(#paint62_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.295 179.622L491.055 163.119L493.784 165.805L500.54 159.148L491.055 149.812L460.782 179.622L491.055 209.437L521.333 179.622L502.813 161.388L487.235 176.727L493.994 183.382L502.813 174.698L507.816 179.622L491.055 196.125L474.295 179.622Z",
    fill: "url(#paint63_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.367 179.622L562.125 163.119L564.854 165.805L571.612 159.148L562.125 149.812L531.852 179.622L562.125 209.437L592.403 179.622L573.885 161.388L558.307 176.727L565.064 183.382L573.885 174.698L578.886 179.622L562.125 196.125L545.367 179.622Z",
    fill: "url(#paint64_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.238 179.423L632.999 162.92L635.727 165.607L642.484 158.95L632.999 149.613L602.725 179.423L632.999 209.238L663.277 179.423L644.756 161.192L629.179 176.531L635.937 183.183L644.756 174.499L649.759 179.423L632.999 195.926L616.238 179.423Z",
    fill: "url(#paint65_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 218.238L42.0331 200.007L26.4557 215.345L33.2122 221.998L42.0331 213.313L47.0339 218.238L30.2735 234.741L13.5154 218.238L30.2735 201.734L33.0018 204.421L39.7607 197.764L30.2735 188.428L0 218.238L30.2735 248.052L60.5517 218.238Z",
    fill: "url(#paint66_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 215.345L671.661 221.998L680.481 213.313L685.482 218.238L668.724 234.741L651.964 218.238L668.724 201.734L671.453 204.421L678.209 197.764L668.724 188.428L638.448 218.238L668.724 248.052L699 218.238L680.481 200.007L664.904 215.345Z",
    fill: "url(#paint67_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.346 248.052L131.622 218.238L113.103 200.007L97.5256 215.345L104.284 221.998L113.103 213.313L118.104 218.238L101.346 234.741L84.5853 218.238L101.346 201.734L104.074 204.421L110.831 197.764L101.346 188.428L71.0699 218.238L101.346 248.052Z",
    fill: "url(#paint68_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.943 218.041L172.217 247.854L202.495 218.041L183.977 199.808L168.399 215.147L175.156 221.801L183.977 213.115L188.977 218.041L172.217 234.542L155.459 218.041L172.217 201.538L174.945 204.225L181.704 197.568L172.217 188.229L141.943 218.041Z",
    fill: "url(#paint69_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.817 218.238L243.09 248.052L273.369 218.238L254.85 200.007L239.273 215.345L246.029 221.998L254.85 213.313L259.851 218.238L243.09 234.741L226.33 218.238L243.09 201.734L245.819 204.421L252.578 197.764L243.09 188.428L212.817 218.238Z",
    fill: "url(#paint70_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.887 218.238L314.163 248.052L344.438 218.238L325.92 200.007L310.342 215.345L317.099 221.998L325.92 213.313L330.921 218.238L314.163 234.741L297.402 218.238L314.163 201.734L316.889 204.421L323.647 197.764L314.163 188.428L283.887 218.238Z",
    fill: "url(#paint71_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.76 218.041L385.034 247.854L415.312 218.041L396.793 199.808L381.216 215.147L387.973 221.801L396.793 213.115L401.794 218.041L385.034 234.542L368.273 218.041L385.034 201.538L387.762 204.225L394.521 197.568L385.034 188.229L354.76 218.041Z",
    fill: "url(#paint72_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.631 218.238L455.907 248.052L486.183 218.238L467.665 200.007L452.087 215.345L458.846 221.998L467.665 213.313L472.665 218.238L455.907 234.741L439.147 218.238L455.907 201.734L458.636 204.421L465.392 197.764L455.907 188.428L425.631 218.238Z",
    fill: "url(#paint73_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.219 218.238L526.977 201.734L529.705 204.421L536.464 197.764L526.977 188.428L496.704 218.238L526.977 248.052L557.255 218.238L538.737 200.007L523.159 215.345L529.916 221.998L538.737 213.313L543.738 218.238L526.977 234.741L510.219 218.238Z",
    fill: "url(#paint74_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09 218.041L597.851 201.538L600.579 204.225L607.336 197.568L597.851 188.229L567.575 218.041L597.851 247.854L628.126 218.041L609.608 199.808L594.031 215.147L600.789 221.801L609.608 213.115L614.609 218.041L597.851 234.542L581.09 218.041Z",
    fill: "url(#paint75_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4215 286.771L95.6997 256.959L77.1812 238.725L61.6037 254.064L68.3603 260.719L77.1812 252.034L82.1819 256.959L65.4215 273.462L48.6634 256.959L65.4215 240.456L68.1498 243.142L74.9087 236.485L65.4215 227.146L35.148 256.959L65.4215 286.771Z",
    fill: "url(#paint76_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.494 286.771L166.77 256.959L148.251 238.725L132.674 254.064L139.432 260.719L148.251 252.034L153.252 256.959L136.494 273.462L119.733 256.959L136.494 240.456L139.222 243.142L145.979 236.485L136.494 227.146L106.218 256.959L136.494 286.771Z",
    fill: "url(#paint77_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.643 256.76L219.125 238.526L203.547 253.868L210.304 260.52L219.125 251.836L224.125 256.76L207.367 273.263L190.607 256.76L207.367 240.257L210.096 242.943L216.852 236.286L207.367 226.95L177.091 256.76L207.367 286.575L237.643 256.76Z",
    fill: "url(#paint78_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.517 256.959L289.998 238.725L274.421 254.064L281.177 260.719L289.998 252.034L294.999 256.959L278.238 273.462L261.48 256.959L278.238 240.456L280.967 243.142L287.726 236.485L278.238 227.146L247.965 256.959L278.238 286.771L308.517 256.959Z",
    fill: "url(#paint79_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.586 256.959L361.068 238.725L345.491 254.064L352.247 260.719L361.068 252.034L366.069 256.959L349.311 273.462L332.55 256.959L349.311 240.456L352.039 243.142L358.795 236.485L349.311 227.146L319.035 256.959L349.311 286.771L379.586 256.959Z",
    fill: "url(#paint80_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.46 256.76L431.941 238.526L416.364 253.868L423.121 260.52L431.941 251.836L436.942 256.76L420.182 273.263L403.424 256.76L420.182 240.257L422.91 242.943L429.669 236.286L420.182 226.95L389.908 256.76L420.182 286.575L450.46 256.76Z",
    fill: "url(#paint81_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.333 256.959L502.813 238.725L487.235 254.064L493.994 260.719L502.813 252.034L507.816 256.959L491.055 273.462L474.295 256.959L491.055 240.456L493.784 243.142L500.54 236.485L491.055 227.146L460.782 256.959L491.055 286.771L521.333 256.959Z",
    fill: "url(#paint82_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.367 256.959L562.125 240.456L564.854 243.142L571.612 236.485L562.125 227.146L531.852 256.959L562.125 286.771L592.403 256.959L573.885 238.725L558.307 254.064L565.064 260.719L573.885 252.034L578.886 256.959L562.125 273.462L545.367 256.959Z",
    fill: "url(#paint83_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.238 256.76L632.999 240.257L635.727 242.943L642.484 236.286L632.999 226.95L602.725 256.76L632.999 286.575L663.277 256.76L644.756 238.526L629.179 253.868L635.937 260.52L644.756 251.836L649.759 256.76L632.999 273.263L616.238 256.76Z",
    fill: "url(#paint84_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 295.575L42.0331 277.341L26.4557 292.682L33.2122 299.334L42.0331 290.65L47.0339 295.575L30.2735 312.078L13.5154 295.575L30.2735 279.071L33.0018 281.758L39.7607 275.101L30.2735 265.764L0 295.575L30.2735 325.389L60.5517 295.575Z",
    fill: "url(#paint85_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 292.682L671.661 299.334L680.481 290.65L685.482 295.575L668.724 312.078L651.964 295.575L668.724 279.071L671.453 281.758L678.209 275.101L668.724 265.764L638.448 295.575L668.724 325.389L699 295.575L680.481 277.341L664.904 292.682Z",
    fill: "url(#paint86_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.346 325.389L131.622 295.575L113.103 277.341L97.5256 292.682L104.284 299.334L113.103 290.65L118.104 295.575L101.346 312.078L84.5853 295.575L101.346 279.071L104.074 281.758L110.831 275.101L101.346 265.764L71.0699 295.575L101.346 325.389Z",
    fill: "url(#paint87_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.495 295.376L183.977 277.145L168.399 292.483L175.156 299.138L183.977 290.451L188.977 295.376L172.217 311.879L155.459 295.376L172.217 278.873L174.945 281.559L181.704 274.902L172.217 265.566L141.943 295.376L172.217 325.191L202.495 295.376Z",
    fill: "url(#paint88_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.369 295.575L254.85 277.341L239.273 292.682L246.029 299.334L254.85 290.65L259.851 295.575L243.09 312.078L226.33 295.575L243.09 279.071L245.819 281.758L252.578 275.101L243.09 265.764L212.817 295.575L243.09 325.389L273.369 295.575Z",
    fill: "url(#paint89_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 295.575L325.92 277.341L310.342 292.682L317.099 299.334L325.92 290.65L330.921 295.575L314.163 312.078L297.402 295.575L314.163 279.071L316.889 281.758L323.647 275.101L314.163 265.764L283.887 295.575L314.163 325.389L344.438 295.575Z",
    fill: "url(#paint90_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.312 295.376L396.793 277.145L381.216 292.483L387.973 299.138L396.793 290.451L401.794 295.376L385.034 311.879L368.273 295.376L385.034 278.873L387.762 281.559L394.521 274.902L385.034 265.566L354.76 295.376L385.034 325.191L415.312 295.376Z",
    fill: "url(#paint91_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.183 295.575L467.665 277.341L452.087 292.682L458.846 299.334L467.665 290.65L472.665 295.575L455.907 312.078L439.147 295.575L455.907 279.071L458.636 281.758L465.392 275.101L455.907 265.764L425.631 295.575L455.907 325.389L486.183 295.575Z",
    fill: "url(#paint92_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.255 295.575L538.737 277.341L523.159 292.682L529.916 299.334L538.737 290.65L543.738 295.575L526.977 312.078L510.219 295.575L526.977 279.071L529.705 281.758L536.464 275.101L526.977 265.764L496.704 295.575L526.977 325.389L557.255 295.575Z",
    fill: "url(#paint93_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09 295.376L597.851 278.873L600.579 281.559L607.336 274.902L597.851 265.566L567.575 295.376L597.851 325.191L628.126 295.376L609.608 277.145L594.031 292.483L600.789 299.138L609.608 290.451L614.609 295.376L597.851 311.879L581.09 295.376Z",
    fill: "url(#paint94_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4215 363.909L95.6997 334.097L77.1812 315.863L61.6037 331.202L68.3603 337.857L77.1812 329.173L82.1819 334.097L65.4215 350.6L48.6634 334.097L65.4215 317.594L68.1498 320.28L74.9087 313.623L65.4215 304.284L35.148 334.097L65.4215 363.909Z",
    fill: "url(#paint95_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77 334.097L148.251 315.863L132.674 331.202L139.432 337.857L148.251 329.173L153.252 334.097L136.494 350.6L119.733 334.097L136.494 317.594L139.222 320.28L145.979 313.623L136.494 304.284L106.218 334.097L136.494 363.909L166.77 334.097Z",
    fill: "url(#paint96_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.643 333.898L219.125 315.667L203.547 331.006L210.304 337.658L219.125 328.974L224.125 333.898L207.367 350.401L190.607 333.898L207.367 317.395L210.096 320.081L216.852 313.425L207.367 304.088L177.091 333.898L207.367 363.713L237.643 333.898Z",
    fill: "url(#paint97_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.517 334.097L289.998 315.863L274.421 331.202L281.177 337.857L289.998 329.173L294.999 334.097L278.238 350.6L261.48 334.097L278.238 317.594L280.967 320.28L287.726 313.623L278.238 304.284L247.965 334.097L278.238 363.909L308.517 334.097Z",
    fill: "url(#paint98_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.586 334.097L361.068 315.863L345.491 331.202L352.247 337.857L361.068 329.173L366.069 334.097L349.311 350.6L332.55 334.097L349.311 317.594L352.039 320.28L358.795 313.623L349.311 304.284L319.035 334.097L349.311 363.909L379.586 334.097Z",
    fill: "url(#paint99_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.46 333.898L431.941 315.667L416.364 331.006L423.121 337.658L431.941 328.974L436.942 333.898L420.182 350.401L403.424 333.898L420.182 317.395L422.91 320.081L429.669 313.425L420.182 304.088L389.908 333.898L420.182 363.713L450.46 333.898Z",
    fill: "url(#paint100_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.333 334.097L502.813 315.863L487.235 331.202L493.994 337.857L502.813 329.173L507.816 334.097L491.055 350.6L474.295 334.097L491.055 317.594L493.784 320.28L500.54 313.623L491.055 304.284L460.782 334.097L491.055 363.909L521.333 334.097Z",
    fill: "url(#paint101_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.403 334.097L573.885 315.863L558.307 331.202L565.064 337.857L573.885 329.173L578.886 334.097L562.125 350.6L545.367 334.097L562.125 317.594L564.854 320.28L571.612 313.623L562.125 304.284L531.852 334.097L562.125 363.909L592.403 334.097Z",
    fill: "url(#paint102_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.238 333.898L632.999 317.395L635.727 320.081L642.484 313.425L632.999 304.088L602.725 333.898L632.999 363.713L663.277 333.898L644.756 315.667L629.179 331.006L635.937 337.658L644.756 328.974L649.759 333.898L632.999 350.401L616.238 333.898Z",
    fill: "url(#paint103_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 372.713L42.0331 354.479L26.4557 369.82L33.2122 376.473L42.0331 367.788L47.0339 372.713L30.2735 389.216L13.5154 372.713L30.2735 356.209L33.0018 358.896L39.7607 352.239L30.2735 342.903L0 372.713L30.2735 402.527L60.5517 372.713Z",
    fill: "url(#paint104_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 369.82L671.661 376.473L680.481 367.788L685.482 372.713L668.724 389.216L651.964 372.713L668.724 356.209L671.453 358.896L678.209 352.239L668.724 342.903L638.448 372.713L668.724 402.527L699 372.713L680.481 354.479L664.904 369.82Z",
    fill: "url(#paint105_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.346 402.527L131.622 372.713L113.103 354.479L97.5256 369.82L104.284 376.473L113.103 367.788L118.104 372.713L101.346 389.216L84.5853 372.713L101.346 356.209L104.074 358.896L110.831 352.239L101.346 342.903L71.0699 372.713L101.346 402.527Z",
    fill: "url(#paint106_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.495 372.514L183.977 354.283L168.399 369.621L175.156 376.276L183.977 367.59L188.977 372.514L172.217 389.017L155.459 372.514L172.217 356.011L174.945 358.697L181.704 352.04L172.217 342.704L141.943 372.514L172.217 402.329L202.495 372.514Z",
    fill: "url(#paint107_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.369 372.713L254.85 354.479L239.273 369.82L246.029 376.473L254.85 367.788L259.851 372.713L243.09 389.216L226.33 372.713L243.09 356.209L245.819 358.896L252.578 352.239L243.09 342.903L212.817 372.713L243.09 402.527L273.369 372.713Z",
    fill: "url(#paint108_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 372.713L325.92 354.479L310.342 369.82L317.099 376.473L325.92 367.788L330.921 372.713L314.163 389.216L297.402 372.713L314.163 356.209L316.889 358.896L323.647 352.239L314.163 342.903L283.887 372.713L314.163 402.527L344.438 372.713Z",
    fill: "url(#paint109_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.312 372.514L396.793 354.283L381.216 369.621L387.973 376.276L396.793 367.59L401.794 372.514L385.034 389.017L368.273 372.514L385.034 356.011L387.762 358.697L394.521 352.04L385.034 342.704L354.76 372.514L385.034 402.329L415.312 372.514Z",
    fill: "url(#paint110_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.183 372.713L467.665 354.479L452.087 369.82L458.846 376.473L467.665 367.788L472.665 372.713L455.907 389.216L439.147 372.713L455.907 356.209L458.636 358.896L465.392 352.239L455.907 342.903L425.631 372.713L455.907 402.527L486.183 372.713Z",
    fill: "url(#paint111_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.255 372.713L538.737 354.479L523.159 369.82L529.916 376.473L538.737 367.788L543.738 372.713L526.977 389.216L510.219 372.713L526.977 356.209L529.705 358.896L536.464 352.239L526.977 342.903L496.704 372.713L526.977 402.527L557.255 372.713Z",
    fill: "url(#paint112_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.09 372.514L597.851 356.011L600.579 358.697L607.336 352.04L597.851 342.704L567.575 372.514L597.851 402.329L628.126 372.514L609.608 354.283L594.031 369.621L600.789 376.276L609.608 367.59L614.609 372.514L597.851 389.017L581.09 372.514Z",
    fill: "url(#paint113_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4215 441.246L95.6997 411.434L77.1812 393.2L61.6037 408.539L68.3603 415.194L77.1812 406.507L82.1819 411.434L65.4215 427.935L48.6634 411.434L65.4215 394.93L68.1498 397.617L74.9087 390.96L65.4215 381.621L35.148 411.434L65.4215 441.246Z",
    fill: "url(#paint114_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.77 411.434L148.251 393.2L132.674 408.539L139.432 415.194L148.251 406.507L153.252 411.434L136.494 427.935L119.733 411.434L136.494 394.93L139.222 397.617L145.979 390.96L136.494 381.621L106.218 411.434L136.494 441.246L166.77 411.434Z",
    fill: "url(#paint115_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.643 411.235L219.125 393.001L203.547 408.34L210.304 414.995L219.125 406.311L224.125 411.235L207.367 427.738L190.607 411.235L207.367 394.732L210.096 397.418L216.852 390.761L207.367 381.423L177.091 411.235L207.367 441.047L237.643 411.235Z",
    fill: "url(#paint116_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.517 411.434L289.998 393.2L274.421 408.539L281.177 415.194L289.998 406.507L294.999 411.434L278.238 427.935L261.48 411.434L278.238 394.93L280.967 397.617L287.726 390.96L278.238 381.621L247.965 411.434L278.238 441.246L308.517 411.434Z",
    fill: "url(#paint117_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.586 411.434L361.068 393.2L345.491 408.539L352.247 415.194L361.068 406.507L366.069 411.434L349.311 427.935L332.55 411.434L349.311 394.93L352.039 397.617L358.795 390.96L349.311 381.621L319.035 411.434L349.311 441.246L379.586 411.434Z",
    fill: "url(#paint118_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.46 411.235L431.941 393.001L416.364 408.34L423.121 414.995L431.941 406.311L436.942 411.235L420.182 427.738L403.424 411.235L420.182 394.732L422.91 397.418L429.669 390.761L420.182 381.423L389.908 411.235L420.182 441.047L450.46 411.235Z",
    fill: "url(#paint119_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.333 411.434L502.813 393.2L487.235 408.539L493.994 415.194L502.813 406.507L507.816 411.434L491.055 427.935L474.295 411.434L491.055 394.93L493.784 397.617L500.54 390.96L491.055 381.621L460.782 411.434L491.055 441.246L521.333 411.434Z",
    fill: "url(#paint120_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.403 411.434L573.885 393.2L558.307 408.539L565.064 415.194L573.885 406.507L578.886 411.434L562.125 427.935L545.367 411.434L562.125 394.93L564.854 397.617L571.612 390.96L562.125 381.621L531.852 411.434L562.125 441.246L592.403 411.434Z",
    fill: "url(#paint121_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.238 411.235L632.999 394.732L635.727 397.418L642.484 390.761L632.999 381.423L602.725 411.235L632.999 441.047L663.277 411.235L644.756 393.001L629.179 408.34L635.937 414.995L644.756 406.311L649.759 411.235L632.999 427.738L616.238 411.235Z",
    fill: "url(#paint122_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5517 450.049L42.0331 431.816L26.4557 447.155L33.2122 453.809L42.0331 445.125L47.0339 450.049L30.2735 466.553L13.5154 450.049L30.2735 433.546L33.0018 436.233L39.7607 429.576L30.2735 420.237L0 450.049L30.2735 479.862L60.5517 450.049Z",
    fill: "url(#paint123_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 447.155L671.661 453.809L680.481 445.125L685.482 450.049L668.724 466.553L651.964 450.049L668.724 433.546L671.453 436.233L678.209 429.576L668.724 420.237L638.448 450.049L668.724 479.862L699 450.049L680.481 431.816L664.904 447.155Z",
    fill: "url(#paint124_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.622 450.049L113.103 431.816L97.5256 447.155L104.284 453.809L113.103 445.125L118.104 450.049L101.346 466.553L84.5853 450.049L101.346 433.546L104.074 436.233L110.831 429.576L101.346 420.237L71.0699 450.049L101.346 479.862L131.622 450.049Z",
    fill: "url(#paint125_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.495 449.851L183.977 431.62L168.399 446.958L175.156 453.611L183.977 444.926L188.977 449.851L172.217 466.354L155.459 449.851L172.217 433.348L174.945 436.034L181.704 429.377L172.217 420.041L141.943 449.851L172.217 479.666L202.495 449.851Z",
    fill: "url(#paint126_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.369 450.049L254.85 431.816L239.273 447.155L246.029 453.809L254.85 445.125L259.851 450.049L243.09 466.553L226.33 450.049L243.09 433.546L245.819 436.233L252.578 429.576L243.09 420.237L212.817 450.049L243.09 479.862L273.369 450.049Z",
    fill: "url(#paint127_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 450.049L325.92 431.816L310.342 447.155L317.099 453.809L325.92 445.125L330.921 450.049L314.163 466.553L297.402 450.049L314.163 433.546L316.889 436.233L323.647 429.576L314.163 420.237L283.887 450.049L314.163 479.862L344.438 450.049Z",
    fill: "url(#paint128_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.312 449.851L396.793 431.62L381.216 446.958L387.973 453.611L396.793 444.926L401.794 449.851L385.034 466.354L368.273 449.851L385.034 433.348L387.762 436.034L394.521 429.377L385.034 420.041L354.76 449.851L385.034 479.666L415.312 449.851Z",
    fill: "url(#paint129_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.183 450.049L467.665 431.816L452.087 447.155L458.846 453.809L467.665 445.125L472.665 450.049L455.907 466.553L439.147 450.049L455.907 433.546L458.636 436.233L465.392 429.576L455.907 420.237L425.631 450.049L455.907 479.862L486.183 450.049Z",
    fill: "url(#paint130_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.255 450.049L538.737 431.816L523.159 447.155L529.916 453.809L538.737 445.125L543.738 450.049L526.977 466.553L510.219 450.049L526.977 433.546L529.705 436.233L536.464 429.576L526.977 420.237L496.704 450.049L526.977 479.862L557.255 450.049Z",
    fill: "url(#paint131_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.126 449.851L609.608 431.62L594.031 446.958L600.789 453.611L609.608 444.926L614.609 449.851L597.851 466.354L581.09 449.851L597.851 433.348L600.579 436.034L607.336 429.377L597.851 420.041L567.575 449.851L597.851 479.666L628.126 449.851Z",
    fill: "url(#paint132_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1812 470.338L61.6037 485.677L68.3603 492.332L77.1812 483.647L82.1819 488.572L65.4215 505.075L48.6634 488.572L65.4215 472.069L68.1498 474.755L74.9087 468.098L65.4215 458.759L35.148 488.572L65.4215 518.384L95.6997 488.572L77.1812 470.338Z",
    fill: "url(#paint133_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.251 470.338L132.674 485.677L139.432 492.332L148.251 483.647L153.252 488.572L136.494 505.075L119.733 488.572L136.494 472.069L139.222 474.755L145.979 468.098L136.494 458.759L106.218 488.572L136.494 518.384L166.77 488.572L148.251 470.338Z",
    fill: "url(#paint134_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.125 470.14L203.547 485.478L210.304 492.133L219.125 483.449L224.125 488.373L207.367 504.876L190.607 488.373L207.367 471.87L210.096 474.556L216.852 467.9L207.367 458.563L177.091 488.373L207.367 518.188L237.643 488.373L219.125 470.14Z",
    fill: "url(#paint135_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.998 470.338L274.421 485.677L281.177 492.332L289.998 483.647L294.999 488.572L278.238 505.075L261.48 488.572L278.238 472.069L280.967 474.755L287.726 468.098L278.238 458.759L247.965 488.572L278.238 518.384L308.517 488.572L289.998 470.338Z",
    fill: "url(#paint136_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.068 470.338L345.491 485.677L352.247 492.332L361.068 483.647L366.069 488.572L349.311 505.075L332.55 488.572L349.311 472.069L352.039 474.755L358.795 468.098L349.311 458.759L319.035 488.572L349.311 518.384L379.586 488.572L361.068 470.338Z",
    fill: "url(#paint137_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.941 470.14L416.364 485.478L423.121 492.133L431.941 483.449L436.942 488.373L420.182 504.876L403.424 488.373L420.182 471.87L422.91 474.556L429.669 467.9L420.182 458.563L389.908 488.373L420.182 518.188L450.46 488.373L431.941 470.14Z",
    fill: "url(#paint138_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.813 470.338L487.235 485.677L493.994 492.332L502.813 483.647L507.816 488.572L491.055 505.075L474.295 488.572L491.055 472.069L493.784 474.755L500.54 468.098L491.055 458.759L460.782 488.572L491.055 518.384L521.333 488.572L502.813 470.338Z",
    fill: "url(#paint139_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.885 470.338L558.307 485.677L565.064 492.332L573.885 483.647L578.886 488.572L562.125 505.075L545.367 488.572L562.125 472.069L564.854 474.755L571.612 468.098L562.125 458.759L531.852 488.572L562.125 518.384L592.403 488.572L573.885 470.338Z",
    fill: "url(#paint140_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.756 470.14L629.179 485.478L635.937 492.133L644.756 483.449L649.759 488.373L632.999 504.876L616.238 488.373L632.999 471.87L635.727 474.556L642.484 467.9L632.999 458.563L602.725 488.373L632.999 518.188L663.277 488.373L644.756 470.14Z",
    fill: "url(#paint141_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4557 524.293L33.2122 530.947L42.0331 522.263L47.0339 527.188L30.2735 543.691L13.5154 527.188L30.2735 510.684L33.0018 513.371L39.7607 506.714L30.2735 497.375L0 527.188L30.2735 557L60.5517 527.188L42.0331 508.954L26.4557 524.293Z",
    fill: "url(#paint142_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.904 524.293L671.661 530.947L680.481 522.263L685.482 527.188L668.724 543.691L651.964 527.188L668.724 510.684L671.453 513.371L678.209 506.714L668.724 497.375L638.448 527.188L668.724 557L699 527.188L680.481 508.954L664.904 524.293Z",
    fill: "url(#paint143_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5256 524.293L104.284 530.947L113.103 522.263L118.104 527.188L101.346 543.691L84.5853 527.188L101.346 510.684L104.074 513.371L110.831 506.714L101.346 497.375L71.0699 527.188L101.346 557L131.622 527.188L113.103 508.954L97.5256 524.293Z",
    fill: "url(#paint144_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.399 524.096L175.156 530.749L183.977 522.065L188.977 526.989L172.217 543.492L155.459 526.989L172.217 510.486L174.945 513.172L181.704 506.515L172.217 497.179L141.943 526.989L172.217 556.804L202.495 526.989L183.977 508.758L168.399 524.096Z",
    fill: "url(#paint145_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.273 524.293L246.029 530.947L254.85 522.263L259.851 527.188L243.09 543.691L226.33 527.188L243.09 510.684L245.819 513.371L252.578 506.714L243.09 497.375L212.817 527.188L243.09 557L273.369 527.188L254.85 508.954L239.273 524.293Z",
    fill: "url(#paint146_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.342 524.293L317.099 530.947L325.92 522.263L330.921 527.188L314.163 543.691L297.402 527.188L314.163 510.684L316.889 513.371L323.647 506.714L314.163 497.375L283.887 527.188L314.163 557L344.438 527.188L325.92 508.954L310.342 524.293Z",
    fill: "url(#paint147_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.216 524.096L387.973 530.749L396.793 522.065L401.794 526.989L385.034 543.492L368.273 526.989L385.034 510.486L387.762 513.172L394.521 506.515L385.034 497.179L354.76 526.989L385.034 556.804L415.312 526.989L396.793 508.758L381.216 524.096Z",
    fill: "url(#paint148_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.087 524.293L458.846 530.947L467.665 522.263L472.665 527.188L455.907 543.691L439.147 527.188L455.907 510.684L458.636 513.371L465.392 506.714L455.907 497.375L425.631 527.188L455.907 557L486.183 527.188L467.665 508.954L452.087 524.293Z",
    fill: "url(#paint149_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.159 524.293L529.916 530.947L538.737 522.263L543.738 527.188L526.977 543.691L510.219 527.188L526.977 510.684L529.705 513.371L536.464 506.714L526.977 497.375L496.704 527.188L526.977 557L557.255 527.188L538.737 508.954L523.159 524.293Z",
    fill: "url(#paint150_linear_224_631)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.031 524.096L600.789 530.749L609.608 522.065L614.609 526.989L597.851 543.492L581.09 526.989L597.851 510.486L600.579 513.172L607.336 506.515L597.851 497.179L567.575 526.989L597.851 556.804L628.126 526.989L609.608 508.758L594.031 524.096Z",
    fill: "url(#paint151_linear_224_631)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_224_631",
    x1: -4.02633e-7,
    y1: 237,
    x2: 402.298,
    y2: 207.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayPattern);
export default __webpack_public_path__ + "static/media/gatewayPattern.99f1c164ed6a0677c657e6b03e15fec8.svg";
export { ForwardRef as ReactComponent };